<template>
  <div>
    <Form
      ref="applyForm"
      :model="apply"
      :rules="applyRules"
      inline
      :label-width="125"
    >
      <div>
        <FormItem
          label="部（股）"
          prop="department"
        >
          <Input
            type="text"
            v-model="apply.department"
            readonly
            placeholder="请输入部（股）"
          >
          </Input>
        </FormItem>
      </div>
      <div>
        <FormItem
          label="出差人"
          prop="businessTraveller"
        >
          <Input
            type="text"
            v-model="apply.businessTraveller"
            readonly
            placeholder="请输入出差人"
          >
          </Input>
        </FormItem>
        <FormItem
          label="事由"
          prop="reasons"
        >
          <Input
            type="text"
            v-model="apply.reasons"
            placeholder="请输入事由"
          >
          </Input>
        </FormItem>
      </div>
      <div>
        <FormItem
          label="起迄日期"
          prop="date"
        >
          <DatePicker
            type="daterange"
            split-panels
            v-model="date"
            placeholder="请选择起迄日期"
          >
          </DatePicker>
        </FormItem>
        <FormItem
          label="出差天数"
          prop="travelDays"
        >
          <Input
            v-model="apply.travelDays"
            placeholder="出差天数"
            @on-change="calculateTotal"
          >
          </Input>
        </FormItem>
      </div>
      <div class="btn-right">
        <Button
          type="primary"
          @click="addApply"
        >新增报销单</Button>
      </div>
      <CTable
        :columns="editColumns"
        :data="apply.erForms"
        class="applyList"
      />
      <FormItem prop="erForms">
        <Input
          type="text"
          placeholder="请添加条码"
          style='display: none'
        >
        </Input>
      </FormItem>
      <Row class="tips">
        <span>核算公式：</span>
        <div>
          <p>{{`1. 出差天数*出差补贴标准/天   =  住宿费+交通费+餐费`}}</p>
          <p>{{`2. 住宿费 >出差天数*出差补贴标准/天*50%`}}</p>
          <p> 3. 合计数=机票+火车+长途+订退标费+住宿费+电话费+交通费+餐费+其他</p>
          <!-- <p>住宿费 > (住宿费 + 交通费 + 餐费) x 50% &nbsp;&nbsp;&nbsp;&nbsp;餐费 <
              50
              x
              出差天数</p
            >
              <p>合计 = 出差标准 x 出差天数 + 飞机票 + 火车轮船票 + 长途汽车票 + 退订票费 + 其他</p> -->
        </div>
      </Row>
      <div>
        <FormItem
          label="机票费"
          prop="planeFee"
        >
          <Input
            type="text"
            v-model="apply.planeFee"
            readonly
            placeholder="机票费"
          >
          </Input>
        </FormItem>
        <FormItem
          label="火车轮船票"
          prop="tsTicket"
        >
          <Input
            type="text"
            v-model="apply.tsTicket"
            readonly
            placeholder="火车轮船票"
          >
          </Input>
        </FormItem>
        <FormItem
          label="其中实名制"
          prop="planeFeeName"
        >
          <Input
            type="text"
            v-model="apply.planeFeeName"
            readonly
            placeholder="其中实名制"
          >
          </Input>
        </FormItem>
      </div>
      <div>
        <FormItem
          label="张数"
          prop="planeFeeFrame"
        >
          <Input
            type="text"
            v-model="apply.planeFeeFrame"
            readonly
            placeholder="张数"
          >
          </Input>
        </FormItem>
        <FormItem
          label="长途汽车费"
          prop="coachFee"
        >
          <Input
            type="text"
            v-model="apply.coachFee"
            readonly
            placeholder="长途汽车费"
          >
          </Input>
        </FormItem>
        <FormItem
          label="其中实名制"
          prop="coachFeeName"
        >
          <Input
            type="text"
            v-model="apply.coachFeeName"
            readonly
            placeholder="其中实名制"
          >
          </Input>
        </FormItem>
      </div>
      <div>
        <FormItem
          label="张数"
          prop="coachFeeFrame"
        >
          <Input
            type="text"
            v-model="apply.coachFeeFrame"
            readonly
            placeholder="张数"
          >
          </Input>
        </FormItem>
        <FormItem
          label="订退票费"
          prop="refundFee"
        >
          <Input
            type="text"
            v-model="apply.refundFee"
            readonly
            placeholder="订退票费"
          >
          </Input>
        </FormItem>
        <FormItem
          label="电话费"
          prop="telephoneFee"
        >
          <Input
            type="text"
            v-model="apply.telephoneFee"
            readonly
            placeholder="电话费"
          >
          </Input>
        </FormItem>
      </div>
      <div>
        <FormItem
          label="住宿费"
          prop="lodgingFee"
        >
          <Input
            type="text"
            v-model="apply.lodgingFee"
            readonly
            placeholder="住宿费"
          >
          </Input>
        </FormItem>
        <FormItem
          label="其中专用发票"
          prop="refundFeeInvoice"
        >
          <Input
            type="text"
            v-model="apply.refundFeeInvoice"
            readonly
            placeholder="其中专用发票"
          >
          </Input>
        </FormItem>
        <FormItem
          label="张数"
          prop="refundFeeFrame"
        >
          <Input
            type="text"
            v-model="apply.refundFeeFrame"
            readonly
            placeholder="张数"
          >
          </Input>
        </FormItem>
      </div>
      <div>
        <FormItem
          label="交通费"
          prop="carFare"
        >
          <Input
            type="text"
            v-model="apply.carFare"
            readonly
            placeholder="交通费"
          >
          </Input>
        </FormItem>
        <FormItem
          label="餐费"
          prop="mealFee"
        >
          <Input
            type="text"
            v-model="apply.mealFee"
            readonly
            placeholder="餐费"
          >
          </Input>
        </FormItem>
        <FormItem
          label="其他"
          prop="other"
        >
          <Input
            type="text"
            v-model="apply.other"
            readonly
            placeholder="其他"
          >
          </Input>
        </FormItem>
      </div>
      <div>
        <FormItem
          label="税金"
          prop="taxes"
        >
          <Input
            type="text"
            v-model="apply.taxes"
            readonly
            placeholder="税金"
          >
          </Input>
        </FormItem>
        <FormItem
          label="总计"
          prop="totals"
        >
          <Input
            type="text"
            v-model="apply.totals"
            readonly
            placeholder="总计"
          >
          </Input>
        </FormItem>
        <FormItem
          label="报销金额大写"
          prop="sayTotal"
        >
          <Input
            type="text"
            v-model="apply.sayTotal"
            readonly
            placeholder="报销金额大写"
          >
          </Input>
        </FormItem>
      </div>
      <Row>
        <Col span="9">
        <FormItem label="附件">
          <Uploader
            :defaultFileList="defaultFileList"
            :downloadPath.sync="apply.enclAddr"
          />
        </FormItem>
        </Col>
      </Row>
      <Row v-if="apply.spList && apply.spList.length > 0">
        <CTable
          :columns="auditColumns"
          :data="apply.spList"
        />
        <FormItem></FormItem>
      </Row>
      <Row v-if="apply.anStatus === '1'">
        <Col span="16">
        <FormItem
          label="审批意见"
          prop="spInfo"
        >
          <Input
            type="textarea"
            v-model="apply.spInfo"
            placeholder="请输入审批意见"
          >
          </Input>
        </FormItem>
        </Col>
      </Row>
      <Row>
        <Col
          span="8"
          offset="8"
        >
        <Alert
          type="error"
          v-if="showErrorHint"
        >
          提示
          <span slot="desc">
            1. 出差天数*出差补贴标准/天 = 住宿费+交通费+餐费
            2. 住宿费 >出差天数*出差补贴标准/天*50%
            <Icon
              type="help-circled"
              size="14"
            ></Icon>
          </span>
        </Alert>
        <template v-if="apply.anStatus === '1'">
          <Button
            type="primary"
            @click="handleSubmit('2')"
            style="width: 45%"
          >审核</Button>
          <Button
            type="default"
            @click="handleSubmit('3')"
            style="width: 45%; margin-left: 5%"
          >驳回
          </Button>
        </template>
        <template v-else>
          <Button
            type="primary"
            @click="handleSubmit('1')"
            style="width: 45%"
            :disabled="showErrorHint"
          >提交</Button>
          <Button
            :disabled="showErrorHint"
            type="primary"
            @click="handleSubmit('0')"
            style="width: 45%; margin-left: 5%"
          >保存
          </Button>
        </template>
        </Col>
      </Row>
    </Form>
  </div>
</template>

<script>
import CTable from '@/components/CTable'
import Uploader from '@/components/Uploader'
import {timeFormat,timeDiff,amountFormat,lowerToCapital} from '@/plugin/tool'
import {applyRules} from '@/plugin/validateRule'
import BtnEvent from "@/components/BtnEvent"

export default {
  name: 'Apply',
  mixins: [BtnEvent],
  components: {
    CTable,
    Uploader
  },
  data () {
    return {
      showErrorHint: false,
      date: [],
      apply: {
        spList: null,
        businessTraveller: null,
        erForms: [],
        planeFee: null,
        tsTicket: null,
        planeFeeName: null,
        planeFeeFrame: null,
        lodgingFee: null,
        coachFee: null,
        coachFeeName: null,
        coachFeeFrame: null,
        refundFee: null,
        telephoneFee: null,
        refundFeeInvoice: null,
        refundFeeFrame: null,
        carFare: null,
        mealFee: null,
        other: null,
        taxes: null
      },
      defaultFileList: [],
      applyRules: applyRules,
      editColumns: [{
        title: '车船开行时间',
        key: 'date',
        minWidth: 120,
        render: (h,params) => {
          return h('DatePicker',{
            props: {
              type: 'daterange',
              transfer: true,
              value: params.row.date
            },
            on: {
              'on-change': (e) => {
                this.apply.erForms[params.index].date=e
                this.apply.erForms[params.index].departureTimeUp=e[0]
                this.apply.erForms[params.index].departureTimeEnd=e[1]
              }
            }
          })
        }
      },{
        title: '车船出发地点',
        key: 'vvDestinationUp',
        minWidth: 120,
        render: (h,params) => {
          return h('Input',{
            props: {
              type: 'text',
              value: params.row.vvDestinationUp
            },
            on: {
              'on-change': (e) => {
                this.apply.erForms[params.index].vvDestinationUp=e.target.value
              }
            }
          })
        }
      },{
        title: '车船到达地点',
        key: 'vvDestinationEnd',
        minWidth: 120,
        render: (h,params) => {
          return h('Input',{
            props: {
              type: 'text',
              value: params.row.vvDestinationEnd
            },
            on: {
              'on-change': (e) => {
                this.apply.erForms[params.index].vvDestinationEnd=e.target.value
              }
            }
          })
        }
      },{
        title: '飞机票',
        key: 'planeFee',
        minWidth: 90,
        render: (h,params) => {
          return h('Input',{
            props: {
              type: 'text',
              value: params.row.planeFee
            },
            on: {
              'on-change': (e) => {
                this.apply.erForms[params.index].planeFee=e.target.value
                this.calculate(params.index)
              }
            }
          })
        }
      },{
        title: '火车轮船票',
        key: 'tsTicket',
        minWidth: 110,
        render: (h,params) => {
          return h('Input',{
            props: {
              type: 'text',
              value: params.row.tsTicket
            },
            on: {
              'on-change': (e) => {
                this.apply.erForms[params.index].tsTicket=e.target.value
                this.calculate(params.index)
              }
            }
          })
        }
      },{
        title: '其中实名制',
        key: 'planeFeeName',
        minWidth: 100,
        render: (h,params) => {
          return h('Input',{
            props: {
              type: 'text',
              value: params.row.planeFeeName
            },
            on: {
              'on-change': (e) => {
                this.apply.erForms[params.index].planeFeeName=e.target.value
                this.calculate(params.index,'1')
              }
            }
          })
        }
      },{
        title: '张数',
        key: 'planeFeeFrame',
        minWidth: 80,
        render: (h,params) => {
          return h('Input',{
            props: {
              type: 'text',
              value: params.row.planeFeeFrame
            },
            on: {
              'on-change': (e) => {
                this.apply.erForms[params.index].planeFeeFrame=e.target.value
                this.calculate(params.index,'1')
              }
            }
          })
        }
      },{
        title: '长途汽车费',
        key: 'coachFee',
        minWidth: 110,
        render: (h,params) => {
          return h('Input',{
            props: {
              type: 'text',
              value: params.row.coachFee
            },
            on: {
              'on-change': (e) => {
                this.apply.erForms[params.index].coachFee=e.target.value
                this.calculate(params.index)
              }
            }
          })
        }
      },{
        title: '其中实名制',
        key: 'coachFeeName',
        minWidth: 110,
        render: (h,params) => {
          return h('Input',{
            props: {
              type: 'text',
              value: params.row.coachFeeName
            },
            on: {
              'on-change': (e) => {
                this.apply.erForms[params.index].coachFeeName=e.target.value
                this.calculate(params.index,'1')
              }
            }
          })
        }
      },{
        title: '张数',
        key: 'coachFeeFrame',
        minWidth: 80,
        render: (h,params) => {
          return h('Input',{
            props: {
              type: 'text',
              value: params.row.coachFeeFrame
            },
            on: {
              'on-change': (e) => {
                this.apply.erForms[params.index].coachFeeFrame=e.target.value
                this.calculate(params.index,'1')
              }
            }
          })
        }
      },{
        title: '订退票费',
        key: 'refundFee',
        minWidth: 100,
        render: (h,params) => {
          return h('Input',{
            props: {
              type: 'text',
              value: params.row.refundFee
            },
            on: {
              'on-change': (e) => {
                this.apply.erForms[params.index].refundFee=e.target.value
                this.calculate(params.index)
              }
            }
          })
        }
      },{
        title: '电话费',
        key: 'telephoneFee',
        minWidth: 100,
        render: (h,params) => {
          return h('Input',{
            props: {
              type: 'text',
              value: params.row.telephoneFee
            },
            on: {
              'on-change': (e) => {
                this.apply.erForms[params.index].telephoneFee=e.target.value
                this.calculate(params.index)
              }
            }
          })
        }
      },{
        title: '住宿费',
        key: 'lodgingFee',
        minWidth: 100,
        render: (h,params) => {
          return h('Input',{
            props: {
              type: 'text',
              value: params.row.lodgingFee
            },
            on: {
              'on-change': (e) => {
                this.apply.erForms[params.index].lodgingFee=e.target.value
                this.calculate(params.index)
              }
            }
          })
        }
      },{
        title: '其中专用发票',
        key: 'refundFeeInvoice',
        minWidth: 110,
        render: (h,params) => {
          return h('Input',{
            props: {
              type: 'text',
              value: params.row.refundFeeInvoice
            },
            on: {
              'on-change': (e) => {
                this.apply.erForms[params.index].refundFeeInvoice=e.target.value
                this.calculate(params.index,'1')
              }
            }
          })
        }
      },{
        title: '张数',
        key: 'refundFeeFrame',
        minWidth: 80,
        render: (h,params) => {
          return h('Input',{
            props: {
              type: 'text',
              value: params.row.refundFeeFrame
            },
            on: {
              'on-change': (e) => {
                this.apply.erForms[params.index].refundFeeFrame=e.target.value
                this.calculate(params.index,'1')
              }
            }
          })
        }
      },{
        title: '交通费',
        key: 'carFare',
        minWidth: 100,
        render: (h,params) => {
          return h('Input',{
            props: {
              type: 'text',
              value: params.row.carFare
            },
            on: {
              'on-change': (e) => {
                this.apply.erForms[params.index].carFare=e.target.value
                this.calculate(params.index)
              }
            }
          })
        }
      },{
        title: '餐费',
        key: 'mealFee',
        minWidth: 100,
        render: (h,params) => {
          return h('Input',{
            props: {
              type: 'text',
              value: params.row.mealFee
            },
            on: {
              'on-change': (e) => {
                this.apply.erForms[params.index].mealFee=e.target.value
                this.calculate(params.index)
              }
            }
          })
        }
      },{
        title: '其他',
        key: 'other',
        minWidth: 100,
        render: (h,params) => {
          return h('Input',{
            props: {
              type: 'text',
              value: params.row.other
            },
            on: {
              'on-change': (e) => {
                this.apply.erForms[params.index].other=e.target.value
                this.calculate(params.index)
              }
            }
          })
        }
      },{
        title: '税金',
        key: 'taxes',
        minWidth: 90,
        render: (h,params) => {
          return h('Input',{
            props: {
              type: 'text',
              value: params.row.taxes
            },
            on: {
              'on-change': (e) => {
                this.apply.erForms[params.index].taxes=e.target.value
                this.calculateTotal()
              }
            }
          })
        }
      },{
        title: '总计',
        key: 'totals',
        minWidth: 90
      },{
        title: '操作',
        key: 'action',
        minWidth: 80,
        align: 'center',
        render: (h,params) => {
          return h('div',[
            h('a',{
              on: {
                click: () => {
                  this.apply.erForms.splice(params.index,1)
                  this.calculateTotal()
                }
              },
              style: {
                marginLeft: '5px'
              }
            },'删除')
          ])
        }
      }],
      userData: null,
      auditColumns: [{
        title: '审核人',
        key: 'userName',
        align: 'center'
      },{
        title: '审核意见',
        key: 'info',
        align: 'center'
      },{
        title: '审核时间',
        key: 'createTime',
        align: 'center'
      }]
    }
  },
  created () {
    if(this.$route.query.id) {
      this.init()
    } else {
      this.addApply()
    }
    this.userData=JSON.parse(sessionStorage.getItem('userData'))
    this.apply.businessTraveller=this.userData.userName
    this.apply.department=this.userData.dptName
  },
  methods: {
    init () {
      this.$fetch('ExpenseReport/getById',{
        id: this.$route.query.id
      }).then(res => {
        if(res.data) {
          this.apply=res.data
          this.date=[res.data.dateUp,res.data.dateEnd]
          _.forEach(res.data.erForms,value => {
            value.date=[value.departureTimeUp,value.departureTimeEnd]
          })
          const _enclAddr=this.apply.enclAddr // 已上传
          if(_enclAddr) {
            this.defaultFileList.push({
              name: _enclAddr.split("file/")[1],
              url: _enclAddr
            })
          }
        }
      })
    },
    addApply () {
      this.apply.erForms.push({
        planeFee: null,
        tsTicket: null,
        planeFeeName: null,
        planeFeeFrame: null,
        lodgingFee: null,
        coachFee: null,
        coachFeeName: null,
        coachFeeFrame: null,
        refundFee: null,
        telephoneFee: null,
        refundFeeInvoice: null,
        refundFeeFrame: null,
        carFare: null,
        mealFee: null,
        other: null,
        taxes: null
      })
    },
    count (...args) {
      let total=0
      args.forEach((val) => {
        total=total+Number(val||0)
      })
      return total+Number(this.apply.travelDays||0)*Number(this.userData.travelStandard)
    },
    countTaxes (data1,data2,data3,data4) {
      return (Number(data1)+Number(data2))/(1+0.09)*0.09+Number(data3)/(1+0.03)*0.03+Number(data4)/(1+0.06)*0.06
    },
    calculate (index,type) { // 横向总计
      const data=this.apply.erForms[index]
      if(type!=='1') {
        this.apply.erForms[index].totals=amountFormat(this.count(data.planeFee,data.tsTicket,data.coachFee,data.refundFee,data.other))
      }
      this.apply.erForms[index].taxes=amountFormat(this.countTaxes(data.planeFee,data.planeFeeName,data.coachFeeName,data.refundFeeInvoice))
      this.calculateTotal()
    },
    calculateTotal () { //纵向总计
      let _planeFee=null
      let _tsTicket=null
      let _planeFeeName=null
      let _planeFeeFrame=null
      let _lodgingFee=null
      let _coachFee=null
      let _coachFeeName=null
      let _coachFeeFrame=null
      let _refundFee=null
      let _telephoneFee=null
      let _refundFeeInvoice=null
      let _refundFeeFrame=null
      let _carFare=null
      let _mealFee=null
      let _other=null
      let _taxes=null
      _.forEach(this.apply.erForms,value => { //起止时间
        _planeFee+=Number(value.planeFee) // 机票
        _tsTicket+=Number(value.tsTicket) // 火车轮船
        _planeFeeName+=Number(value.planeFeeName)
        _planeFeeFrame+=Number(value.planeFeeFrame) // 张数
        _coachFee+=Number(value.coachFee) // 长途汽车
        _coachFeeName+=Number(value.coachFeeName)
        _coachFeeFrame+=Number(value.coachFeeFrame) // 张数
        _refundFee+=Number(value.refundFee) // 订退票
        _telephoneFee+=Number(value.telephoneFee) // 电话
        _lodgingFee+=Number(value.lodgingFee) // 住宿费
        _refundFeeInvoice+=Number(value.refundFeeInvoice)
        _refundFeeFrame+=Number(value.refundFeeFrame) // 张数
        _carFare+=Number(value.carFare) // 交通
        _mealFee+=Number(value.mealFee) // 餐费
        _other+=Number(value.other) // 其他
        _taxes+=Number(value.taxes) // 其他
      })
      this.apply.planeFee=amountFormat(_planeFee)
      this.apply.tsTicket=amountFormat(_tsTicket)
      this.apply.planeFeeName=amountFormat(_planeFeeName)
      this.apply.planeFeeFrame=_planeFeeFrame
      this.apply.coachFee=amountFormat(_coachFee)
      this.apply.coachFeeName=amountFormat(_coachFeeName)
      this.apply.coachFeeFrame=_coachFeeFrame
      this.apply.refundFee=amountFormat(_refundFee)
      this.apply.telephoneFee=amountFormat(_telephoneFee)
      this.apply.lodgingFee=amountFormat(_lodgingFee)
      this.apply.refundFeeInvoice=amountFormat(_refundFeeInvoice)
      this.apply.refundFeeFrame=_refundFeeFrame
      this.apply.carFare=amountFormat(_carFare)
      this.apply.mealFee=amountFormat(_mealFee)
      this.apply.other=amountFormat(_other)
      this.apply.taxes=amountFormat(_taxes)
      // 合计数=机票+火车+长途+订退标费+住宿费+电话费+交通费+餐费+其他
      // 合计金额= 出差天数*出差补贴标准/天+机票+火车+长途+订退票费+电话费+其他
      this.apply.totals=amountFormat(this.count(_planeFee,_tsTicket,_coachFee,_refundFee,_other,_telephoneFee,_lodgingFee,_carFare,_mealFee))
      this.apply.sayTotal=lowerToCapital(this.apply.totals)
      // 1. 住宿费〉出差天数*出差补贴标准/天*50%
      let failed=_lodgingFee<=((Number(this.apply.travelDays||0)*Number(this.userData.travelStandard))*0.5)
      this.showErrorHint=(_lodgingFee+_carFare+_mealFee)!=(Number(this.apply.travelDays||0)*Number(this.userData.travelStandard))||failed
    },
    updatePath (path) {
      this.apply.enclAddr=path
    },
    handleSubmit (type) {
      if(type==='3') {
        this.$fetch('ExpenseReport/bohui',{
          spInfo: this.apply.spInfo,
          id: this.apply.id
        }).then(res => {
          this.$Message.info({
            content: '操作成功',
            onClose: () => {
              this.updatePage('ApplyAccountList')
            }
          })
        })
      } else {
        this.$refs.applyForm.validate((valid) => {
          if(valid) {
            this.apply.departureTimeUp=timeFormat(this.date[0],'date')
            this.apply.departureTimeEnd=timeFormat(this.date[1],'date')
            _.forEach(this.apply.erForms,value => {
              value.planeFee=amountFormat(value.planeFee)
              value.tsTicket=amountFormat(value.tsTicket)
              value.planeFeeName=amountFormat(value.planeFeeName)
              value.coachFee=amountFormat(value.coachFee)
              value.coachFeeName=amountFormat(value.coachFeeName)
              value.refundFee=amountFormat(value.refundFee)
              value.telephoneFee=amountFormat(value.telephoneFee)
              value.lodgingFee=amountFormat(value.lodgingFee)
              value.refundFeeInvoice=amountFormat(value.refundFeeInvoice)
              value.carFare=amountFormat(value.carFare)
              value.mealFee=amountFormat(value.mealFee)
              value.other=amountFormat(value.other)
            })
            // this.apply.reimburseDate = timeFormat(this.apply.reimburseDate, 'date')
            this.apply.spStatus=type
            this.$fetch(type==='2'? 'ExpenseReport/spSave':'ExpenseReport/save',this.apply,'POST').then(res => {
              this.$Message.info({
                content: '操作成功',
                onClose: () => {
                  this.updatePage('ApplyAccountList')
                }
              })
            })
          }
        })
      }
    }
  }
}
</script>

<style lang="less">
.applyList {
  .ivu-table-cell {
    padding-left: 10px;
    padding-right: 10px;
  }
}
</style>
